import { render, staticRenderFns } from "./FullModal.vue?vue&type=template&id=048c8049&scoped=true&"
import script from "./FullModal.vue?vue&type=script&lang=js&"
export * from "./FullModal.vue?vue&type=script&lang=js&"
import style0 from "./FullModal.vue?vue&type=style&index=0&id=048c8049&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048c8049",
  null
  
)

export default component.exports